export function expandPadding(value) {
  return expandStyle(value, "padding{}");
}

export function expandMargin(value) {
  return expandStyle(value, "margin{}");
}

// TODO: Oh man, why did I set the arguments in that order? That's not
// right...
export function expandBorder(value, property) {
  return expandStyle(value, `border{}${property}`);
}

/**
 * Expand a style to all edges.
 *
 * `value` is the value to be applied to the edges. The value can be a
 * constant, or an array. An array indicates either a value per edge
 * (if there are 4 elements in the array) or, if there are 2 values,
 * they specify the values for the top/bottom and left/right edges,
 * respectively. Note that individual edge values can also themselves
 * be arrays, indicating values per breakpoint.
 *
 * `template` defines how the edge name is injected into the style,
 * adjacent mustachios are the key to be replaced by the edge name,
 * e.g.  "border{}Color".
 */
function expandStyle(value, template) {
  const edges = ["Top", "Right", "Bottom", "Left"];
  function getValue(i) {
    if (Array.isArray(value)) {
      i = i % value.length;
      return value[i];
    }
    return value;
  }
  return edges
    .map((e) => template.replace("{}", e))
    .reduce((a, b, i) => ({ ...a, [b]: getValue(i) }), {});
}

export function expandBorderRadius(value) {
  return {
    borderTopLeftRadius: value,
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderBottomLeftRadius: value,
  };
}

export function expandResponsive(value, template) {
  if (Array.isArray(value)) {
    return value.map((v) => template.replace("{}", v));
  }
  return template.replace("{}", value);
}
